import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '',
      component: () => import('@/pages/base'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/pages/home'),
        },
        {
          path: 'faq',
          name: 'faq',
          component: () => import('@/pages/faq'),
        },
        {
          path: 'funding',
          name: 'funding',
          component: () => import('@/pages/funding'),
        },
        {
          path: 'contact',
          name: 'contact',
          component: () => import('@/pages/contact'),
        },
        {
          path: 'inputs',
          name: 'inputs',
          component: () => import('@/pages/inputs'),
        },
        {
          path: 'sign/:token',
          name: 'sign',
          component: () => import('@/pages/sign'),
          props: true
        },
        {
          path: 'finish',
          name: 'finish',
          component: () => import('@/pages/finish'),
        },
        {
          path: 'privacy',
          name: 'privacy',
          component: () => import('@/pages/privacy'),
        },
        {
          path: 'impressum',
          name: 'impressum',
          component: () => import('@/pages/impressum'),
        },
        {
          path: 'disabled',
          name: 'disabled',
          component: () => import('@/pages/disabled'),
        },
        {
          path: 'error',
          name: 'error',
          component: () => import('@/pages/error'),
        },
      ]
    },
  ]
})

export default router
